import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-78c4b120")

_pushScopeId("data-v-78c4b120")
const _hoisted_1 = {
  key: 0,
  class: "bg-red-500 text-white text-xs text-right absolute px-2 font-light absolute -top-1 -right-1 pointer-events-none rounded-bl-md rounded-tr-md"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute -bottom-1 -right-1 text-xs text-white user-select-none bg-green-600 px-2 py-0 rounded-tl-lg rounded-br-lg"
}
const _hoisted_3 = { class: "w-full cursor-pointer text-gray-700 select-none px-2 py-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", {
    class: `rounded-sm relative mb-3 ring-2 ${_ctx.ring} border-2 modal ${_ctx.cssTag} ${
      _ctx.disabled
        ? 'bg-gray-200 pointer-events-none border-gray-200'
        : 'bg-white border-white'
    }`,
    style: {"box-sizing":"content-box !important"}
  }, [
    (_ctx.showErrorMessage)
      ? (_openBlock(), _createBlock("p", _hoisted_1, " Campo Requerido "))
      : _createCommentVNode("", true),
    (_ctx.value && _ctx.description)
      ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.description.label) + ": " + _toDisplayString(_ctx.description.value), 1))
      : _createCommentVNode("", true),
    (_ctx.dismissible)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: `absolute right-2 top-2 bottom-0 flex items-center -mt-2 cursor-pointer text-gray-500 modal ${!_ctx.value ? 'pointer-events-none':''}`,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unselect && _ctx.unselect(...args)))
        }, [
          (_ctx.value)
            ? (_openBlock(), _createBlock(_component_fa_icon, {
                key: 0,
                icon: ['fas', 'times']
              }))
            : (_openBlock(), _createBlock(_component_fa_icon, {
                key: 1,
                icon: ['fas', 'caret-down']
              }))
        ], 2))
      : _createCommentVNode("", true),
    _createVNode("div", null, [
      (_ctx.value)
        ? (_openBlock(), _createBlock("p", {
            key: 0,
            class: `absolute -top-2 left-0 ${_ctx.labelColor} text-white text-xs px-2 rounded-md shadow-xs`
          }, _toDisplayString(_ctx.label), 3))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter = $event)),
          placeholder: _ctx.label,
          onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
          class: _ctx.disabled ? 'bg-gray-200':'bg-white modal ' + _ctx.cssTag,
          disabled: _ctx.disabled,
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 42, ["placeholder", "disabled"]), [
          [_vModelText, _ctx.filter]
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "options-animation" }, {
      default: _withId(() => [
        (_ctx.showOptions && _ctx.filteredItems.length > 0 && !_ctx.disabled)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: `
        ${_ctx.cssTag}
          modal
          bg-white
          shadow-md
          rounded-sm
          absolute
          left-1
          right-1
          top-5
          z-40
          divide-y
          mt-1
          overflow-hidden
          border-2 border-green-50`
        ,
              id: "options-container",
              style: `max-height: ${_ctx.maxHeight}px; overflow-y: scroll`
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item, i) => {
                return (_openBlock(), _createBlock("p", {
                  class: `
            modal
            px-3
            py-1
            cursor-pointer
            bg-gray-100
            hover:bg-white
            transition-all
            duration-300
            text-gray-400
            hover:text-gray-700
            item-display ${_ctx.cssTag}`
          ,
                  key: item.id,
                  id: item.id,
                  tabindex: i,
                  onClick: ($event: any) => (_ctx.onSelect(item)),
                  onKeyup: [
                    _withKeys(($event: any) => (_ctx.onSelect(item)), ["enter"]),
                    _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.isPressingDown && _ctx.isPressingDown(...args)), ["down"])),
                    _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.isPressingUp && _ctx.isPressingUp(...args)), ["up"]))
                  ]
                }, _toDisplayString(item.label), 43, ["id", "tabindex", "onClick", "onKeyup"]))
              }), 128))
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
})